import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import { Link } from "react-router-dom";
import "./style.scss";
import AuthLayout from "../../../components/authlayout";
import methodModel from "../../../methods/methods";
import { useDispatch } from "react-redux";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import { login_success } from "../../../redux/actions/user";

const Login = () => {
  const history = useNavigate()
  const token = sessionStorage.getItem("token")
  const dispatch = useDispatch()
  const [username, setUsername] = useState("")
  const [remember, setRemember] = useState(false)
  const [password, setPassword] = useState("")
  const [eyes, setEyes] = useState({ password: false, confirmPassword: false, currentPassword: false })

  useEffect(() => {
    if (token) {
      history("/dashboard")
    }
    let r = sessionStorage.getItem("remember")
    if (r) {
      let data = JSON.parse(r)
      setUsername(data.email)
      setPassword(data.password)
      setRemember(true)
    }
    let id = methodModel.getPrams("id")
    if (id) handleAutoLogin(id)
  }, []);

  const handleAutoLogin = (userId: string) => {
    ApiClient.post(`user/auto/login`, { id: userId }).then((res: any) => {
      if (res.success) {
        handleUserRedirection(res)
      }
    })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    let data: any = {
      email: username,
      password,
    }
    let url = "user/login"
    loader(true)
    ApiClient.post(url, data).then(async (res) => {
      if (res.success) {
        // if (remember) {
        //   sessionStorage.setItem("remember", JSON.stringify(data))
        // } else {
        //   sessionStorage.removeItem("remember")
        // }
        handleUserRedirection(res)
      } else {
        toast?.error(res?.message)
        loader(false)
      }
    })
  }

  const handleUserRedirection = (res: any) => {
    sessionStorage.setItem("homepage", "false")
    sessionStorage.setItem("token", res?.data?.access_token)
    dispatch(login_success(res?.data))
    loader(false)
    const cardId = methodModel.getPrams("cardId")
    if (cardId) {
      history(`/mycard/${cardId}`)
    } else {
      history("/")
    }
  }

  return (
    <>
      <AuthLayout>
        <div className="w-[100%] lg:w-[80%]">
          <img src="/assets/img/ed/logopng.png" onClick={() => history(`/`)} className="w-[200px] mx-auto pb-6 cursor-pointer" alt="logo" />
          <form className="w-full  mx-auto" onSubmit={handleSubmit} autoComplete="one-time-code">
            <div className="text-center">
              <h1 className="text-[24px] font-semibold text-black">Login to your account</h1>
              <span className="flex w-10 mx-auto h-1 bg-[#F58D18] mt-1"></span>
            </div>
            <div className="mt-5">
              <input type="text" className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[14px]" placeholder="Email" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="one-time-code" />
              <div className="relative">
                <input type={eyes.password ? "text" : "password"} className="mb-4 w-full text-sm text-[#222] h-12 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[10px]" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required autoComplete="one-time-code" />
                {eyes.password ? (
                  <FiEye className="top-1/2 -translate-y-1/2 right-3 absolute text-[#222] cursor-pointer" onClick={() => setEyes({ ...eyes, password: !eyes.password })} />
                ) : (
                  <FiEyeOff className="top-1/2 -translate-y-1/2 right-3 absolute text-[#222] cursor-pointer" onClick={() => setEyes({ ...eyes, password: !eyes.password })} />
                )}
              </div>
            </div>
            <div className="flex">
              <Link className="font-normal text-[14px] ml-auto text-[#EB6A59]" to="/forgotpassword">{" "}Forgot Password?</Link>
            </div>
            <div className="mt-4 flex items-center justify-center">
              <button type="submit" className="h-11 rounded-[10px] w-full font-semibold text-center text-[#fff] hover:opacity-80 transition-all">Sign in</button>
            </div>
            <p className="text-[14px] mt-4 text-center font-normal text-black">Don't have an account? <Link className="text-[#EB6A59] font-semibold text-[14px]" to="/register">Sign Up</Link></p>
          </form>
        </div>
      </AuthLayout>
    </>
  );
};

export default Login;
